import { getClaimSync, getSentRowSync } from '@/features/appeals/store';

/**
 * An appeal link in the log names a claim. Which page holds that claim depends on
 * where its appeal stands right now: Appeals sent once it has gone out, the denied
 * queue before that. Returns null when neither page has it, so no dead link shows.
 */
export function appealHref(href: string): string | null {
  const m = /^\/denied\/appeals\/([^/?#]+)$/.exec(href);
  if (!m) return href;
  const id = m[1] ?? '';
  if (getSentRowSync(id)) return `/denied/appeals/${id}`;
  if (getClaimSync(id)) return `/denied/${id}`;
  return null;
}
